

<template lang="pug">
	.busca__wrapper(:class="{ busca__wrapper_highlight: toggle_border_highlight, busca__wrapper_has_suggestions : check_show_suggestions }")
		.busca__inner
			.busca__search_container
				input(placeholder="O que você procura?", v-model="search_term", @focus="enable_search_highlight", @blur="disable_search_highlight", @keyup.enter="fire_search")
				.busca__actions
					a(href="javascript:void(0);", v-if="show_clear", @click="clear_search_term").busca__limpar Limpar
					a(href="javascript:void(0);", @click="fire_search").busca__search Procurar
			.busca__suggestions(v-if="check_show_suggestions")
				ul
					li(v-for="item in find_suggestions")
						a(href="javascript:void(0);", v-hamburger-link, @click="change_search_term(item)") {{item}}
</template>

<script>
import Search_Index from "@/assets/search_index.json";

export default {
	name: "SearchComponent",
	props: [ 'term' ],
	data: function() {
		return {
			search_term: "" + this.term,
			toggle_border_highlight: false,
			show_suggestions: false
		}
	},
	methods: {
		clear_search_term: function() {
			this.search_term = '';
		},
		enable_search_highlight: function() {
			this.toggle_border_highlight = true;
			this.show_suggestions = true;
		},
		disable_search_highlight: function() {
			this.toggle_border_highlight = false;
		},
		fire_search: function() {
			if (this.search_term.length >= 3) {
				const currentRoute = this.$router.currentRoute;

				if (currentRoute.name == 'busca_resultado') {
					if (currentRoute.params['term'] == this.search_term) {
						return false;
					}
				}

				this.$router.push({ name: 'busca_resultado', params: { term: this.search_term } });
			}
		},
		change_search_term: function(word) {
			this.search_term = word;
			this.$router.push({ name: 'busca_resultado', params: { term: word } });
			this.show_suggestions = false;
		}
	},
	computed: {
		show_clear: function() {
			if (this.search_term && this.search_term.length > 0) return true;
			return false;
		},
		find_suggestions: function() {
			if (this.search_term.length < 3) return [];

			return Object.keys(Search_Index).filter(f => {
				return f.indexOf(this.search_term) > -1;
			});
		},
		check_show_suggestions: function() {
			return this.find_suggestions.length > 0 && this.show_suggestions;
		}
	}
}
</script>